
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IconButton from '@mui/material/IconButton';
import Upload from '@mui/icons-material/Upload';
import { Delete, Edit, Preview, Download } from '@mui/icons-material';
import DeleteDialog from "./DeleteDialog";


import { useState, useEffect } from 'react';


import Config from '../../../config.json';
import { getCookie, dateToString } from '../../../Helpers';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function GazetteerTable() {
  const token = getCookie('USER_TOKEN');
  const public_id = getCookie('PUBLIC_ID');

  const [list, setList] = useState(null);

  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [dataId, setDataId] = useState();

  const url_list = "../api/metadata/produsen/" + public_id;

  const handleClickOpen = (dataId) => {
    setOpen(true);
    setDataId(dataId)
  };


  useEffect(() => {

    try {
      // Fetch data from REST API
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      };

      fetch(url_list, requestOptions).then(res => res.json()).then(data => {
        setList(data.data);
        //  if (data.status === "Expired token") {
      });

    } catch (error) {
      alert(`Error ${error}`)
    }
  }, []);


  useEffect(() => {

    try {
      // Fetch data from REST API
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      };

      fetch(url_list, requestOptions).then(res => res.json()).then(data => {
        //console.log(data)
        if (data)
          setList(data.data);
        //  if (data.status === "Expired token") {
      });
      setRefresh(false)

    } catch (error) {
      alert(`Error ${error}`)
    }
  }, [refresh]);

  function showDelete(row) {
    if (!row.status) {
      return (
        <IconButton aria-label="post message" component="a" onClick={() => handleClickOpen(row.id)}>
          <Delete />
        </IconButton>
      )
    }
  }

  function getRows() {
    if (typeof (list) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (list !== null) {

        if (list.length > 0) {

          return list.map((row, index) => {
            //console.log(row
            let dateISO = new Date(row.time_uploaded);
            //console.log(dateISO.getTimezoneOffset())

            let formatted_datetime = dateToString(dateISO);
            return (
              <StyledTableRow key={row.id}>
                <StyledTableCell component="th" scope="row">
                  {row.filename}
                </StyledTableCell>
                <StyledTableCell>{formatted_datetime}</StyledTableCell>
                <StyledTableCell>{row.status ? 'Approved by Walidata' : 'Waiting for approval'}</StyledTableCell>
                <StyledTableCell>
                  <IconButton aria-label="post message" component="a" href={"#/metadata/preview/" + row.id}>
                    <Preview />
                  </IconButton>
                  <IconButton aria-label="post message" component="a" href={"../api/metadata/download/" + row.id} >
                    <Download />
                  </IconButton>
                  {showDelete(row)}
                </StyledTableCell>
              </StyledTableRow>
            )
          })
        } else {
          return (
            <StyledTableRow >
              <StyledTableCell component="th" scope="row" colspan="7">
                No data found.
              </StyledTableCell>
            </StyledTableRow>
          )
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  /*
    <IconButton aria-label="post message" component="a" href={"#/metadata/edit/" + row.id}>
                    <Edit />
                  </IconButton>

  */
  return (
    <TableContainer component={Paper}>
      <DeleteDialog open={open} setOpen={(e) => setOpen(e)} dataId={dataId} setRefresh={(e) => setRefresh(e)} />
      <Table stickyHeader sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Metadata File	</StyledTableCell>
            <StyledTableCell>Time Uploaded	</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {
            getRows()

          }

        </TableBody>
      </Table>
    </TableContainer>
  )
}